<template>
  <div class="beta">
    <div class="container">
      <div class="inner">
        <img class="logo" src="@/assets/nklogo_.png" width="150" />

        <h1>パスワードの再設定</h1>

        <p>新しいパスワードを入力してください。</p>

        <div class="guide-container">
          <p class="guide"></p>
        </div>

        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
        >
          <el-form-item label="パスワード" prop="pass">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
            <div class="strength">{{ passStrength }}</div>
          </el-form-item>

          <el-form-item class="passInput" label="確認パスワード" prop="checkPass">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <button
              class="button"
              type="primary"
              :class="{ 'loading disabled': loading }"
              @click.prevent="submitForm('ruleForm')"
            >{{ loading ? "パスワードを変更中" : "パスワードを変更" }}</button>
            <button
              class="button white"
              @click.prevent="resetForm('ruleForm')"
              style="margin-left: 20px"
            >リセット</button>
          </el-form-item>
        </el-form>

        <!-- <el-alert
          title="メールを送信しました"
          type="success"
          description="ご入力頂いたメールアドレスに確認用のメールを送信しました。メールに記載されているURLをクリックして本登録を完了してください。"
          show-icon
        ></el-alert>-->

        <el-alert
          :title="`エラーが発生しました (error code: ${errCode})`"
          type="error"
          :description="errDescription"
          show-icon
          v-show="err"
        ></el-alert>

        <button class="button white" style="margin-top: 20px" @click="back">サインインページに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
const zxcvbn = require("zxcvbn");
import "firebase/functions";

export default {
  name: "ForgotPassword",
  mounted() {
    // if (this.$store.state.auth.user.uid) {
    //   firebase.auth().signOut();
    //   this.$router.go({ path: this.$router.currentRoute.path, force: true });
    // }
  },
  watch: {
    ruleForm: {
      deep: true,
      handler: function(input) {
        var result = ["弱い", "少し弱い", "中", "少し強い", "強い"];
        var score = zxcvbn(input.pass).score;
        this.passStrength = result[score];
      }
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードを入力してください"));
      } else if (value.length < 8) {
        callback(new Error("パスワードは8文字以上入力してください"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードを入力してください"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("2つのパスワードが異なっています"));
      } else {
        callback();
      }
    };
    return {
      passStrength: "",
      ruleForm: {
        pass: "",
        checkPass: ""
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      createErrorMessage: " ",
      email: "",
      loading: false,
      password: "",
      pending: false,
      message: " ",
      form: {
        name: "",
        password: ""
      }
    };
  },
  methods: {
    submitForm(formName) {
      let self = this;
      let email = "";
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loading = true;
          let self = this;
          const auth = firebase.auth();
          auth
            .verifyPasswordResetCode(self.$route.query.oobCode)
            .then(result => {
              email = result;
              console.log(result);
              return auth.confirmPasswordReset(
                self.$route.query.oobCode,
                self.ruleForm.pass
              );
            })
            .then(result => {
              const sendChangedPasswordEmail = firebase
                .functions()
                .httpsCallable("sendChangedPasswordEmail");
              console.log(email);
              sendChangedPasswordEmail({ email: email });
              self.$notify({
                type: "success",
                title: "成功",
                duration: 10000,
                message:
                  "パスワードの変更が完了しました。数秒後にサインイン画面へ移動します。"
              });
              setTimeout(() => {
                self.$router.replace("/");
              }, 1000);
            })
            .catch(err => {
              console.log(err);
              self.$notify({
                type: "error",
                title: "失敗",
                message:
                  "パスワードの変更に失敗しました。有効なパスワードをしてください。"
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    back() {
      this.$router.replace("/");
    },
    sendResetMail() {
      this.loading = true;
      let self = this;
      const auth = firebase.auth();
      auth
        .verifyPasswordResetCode(this.$route.query.oobCode)
        .then(uid => {
          console.log(uid);
        })
        .catch(err => {
          // self.errCode = err.code;
          // self.errDescription = err.message;
          // self.loading = false;
          // self.err = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
  text-align: left;
  margin: 35px 0;
}
.inner {
  max-width: 50%;
  margin: 0 auto;
}

.button-container {
  text-align: center;
}

.register {
  margin: 20px 0;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.guide-container {
  margin: 30px;
  font-weight: bold;
}

.forgot {
  margin-top: 10px;
  color: #999;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
  cursor: pointer;
  &:hover {
    color: #777;
  }
}
.error {
  color: #f88;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
}

.strength {
  position: absolute;
  font-size: 0.8rem;
  font-weight: bold;
  top: 0;
  right: 30px;
  bottom: 0;
  margin: 0 auto;
}

.passInput {
  position: relative;
}
</style>